import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularHelperService from '../../services/angular-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-notification',
	templateUrl: './item-notification.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class ItemNotificationComponent implements OnInit {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() btnText: any | undefined;
	@Input() icon: any | undefined;
	@Input() action: any | undefined;
	@Input() theme: any | undefined;
	@Input() narrow: any | undefined;
	@Input() text: any;
	@Input() href: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.content = this.angularHelperService.trustAsHtml(this.vm.text);
	}
	
}